import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CONSTANTS from "../utils/constants";

export default function AboutUs() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    aboutUsText_tm: "",
    aboutUsText_ru: "",
    aboutUsText_en: "",
    termsOfUseText_tm: "",
    termsOfUseText_ru: "",
    termsOfUseText_en: "",
    phoneNumber: "",
    email: "",
    address1_tm: "",
    address1_ru: "",
    address1_en: "",
    address2_tm: "",
    address2_ru: "",
    address2_en: "",
    instagramUrl: "",
    tiktokUrl: ""
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetch(`${CONSTANTS.baseRoute}/about-us`)
      .then(res => res.json())
      .then(data => setFormData(data))
      .catch(err => console.error("Fetch error:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const res = await fetch(`${CONSTANTS.baseRoute}/about-us/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      if (!res.ok) throw new Error("Server error");

      alert(t("aboutcommon.saved"));
    } catch (err) {
      alert(t("aboutcommon.error"));
    } finally {
      setIsLoading(false);
    }
  };

  const languages = [
    { code: "tm", name: t("languages.tm") },
    { code: "ru", name: t("languages.ru") }
  ];

  return (
    <div className="admin-main py-2 ps-2 pe-3">
      <div className="d-flex gap-2 align-items-center mb-2">
        <button className="btn btn-light" onClick={() => navigate(-1)}>
          <i className="bi bi-chevron-left"></i>
        </button>
        <button className="btn btn-light" onClick={() => navigate(+1)}>
          <i className="bi bi-chevron-right"></i>
        </button>
        <h5 className="fw-bold">{t("about.title")}</h5>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-8">
            {/* ABOUT TEXT */}
            <div className="card mb-4">
              <div className="card-header">
                <h6 className="mb-0">{t("about.aboutText")}</h6>
              </div>
              <div className="card-body">
                {languages.map(lang => (
                  <div key={lang.code} className="mb-3">
                    <label className="form-label">
                      {lang.name} – {t("about.aboutText")}
                    </label>
                    <textarea
                      className="form-control"
                      rows="5"
                      name={`aboutUsText_${lang.code}`}
                      value={formData[`aboutUsText_${lang.code}`]}
                      onChange={handleChange}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* TERMS */}
            <div className="card">
              <div className="card-header">
                <h6 className="mb-0">{t("about.termsText")}</h6>
              </div>
              <div className="card-body">
                {languages.map(lang => (
                  <div key={lang.code} className="mb-3">
                    <label className="form-label">
                      {lang.name} – {t("about.termsText")}
                    </label>
                    <textarea
                      className="form-control"
                      rows="5"
                      name={`termsOfUseText_${lang.code}`}
                      value={formData[`termsOfUseText_${lang.code}`]}
                      onChange={handleChange}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            {/* CONTACT */}
            <div className="card mb-4">
              <div className="card-body">
                <h5>{t("about.contact")}</h5>
                <div className="mb-3">
                  <label className="form-label">{t("about.phone")}</label>
                  <input
                    className="form-control"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">{t("about.email")}</label>
                  <input
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* ADDRESS */}
            <div className="card mb-4">
              <div className="card-header">
                <h6 className="mb-0">{t("about.address")}</h6>
              </div>
              <div className="card-body">
                {languages.map(lang => (
                  <div key={lang.code}>
                    <h6 className="small text-muted">{lang.name}</h6>
                    <input
                      className="form-control mb-2"
                      placeholder={t("about.address1")}
                      name={`address1_${lang.code}`}
                      value={formData[`address1_${lang.code}`]}
                      onChange={handleChange}
                    />
                    <input
                      className="form-control mb-3"
                      placeholder={t("about.address2")}
                      name={`address2_${lang.code}`}
                      value={formData[`address2_${lang.code}`]}
                      onChange={handleChange}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* SOCIAL */}
            <div className="card">
              <div className="card-body">
                <h5>{t("about.social")}</h5>
                <input
                  className="form-control mb-2"
                  placeholder="Instagram URL"
                  name="instagramUrl"
                  value={formData.instagramUrl}
                  onChange={handleChange}
                />
                <input
                  className="form-control"
                  placeholder="TikTok URL"
                  name="tiktokUrl"
                  value={formData.tiktokUrl}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        <button className="btn btn-primary w-100 mt-4" disabled={isLoading}>
          {isLoading ? t("aboutcommon.loading") : t("aboutcommon.save")}
        </button>
      </form>
    </div>
  );
}
